import { Alert, Button, Dialog, Form, FormDatas, Spin } from "@weapp/ui";
import { ResetPassDialogProps } from "./type";
import React from "react";
import ReactDOM from "react-dom";
import { getLabel, middleware } from "@weapp/utils";
import { withStores } from "../../../../utils/withStore";
import { ResetPassStore } from "./store";
import { inject, observer } from "mobx-react";
import { passportClsPrefix } from "../../../../constants";
import "./style/index.less";
import { PasswordStrength } from "./strength";

const clsPrefix = `${passportClsPrefix}-resetpass-dialog`

@withStores({ resetPassStore: new ResetPassStore() })
@inject('resetPassStore')
@middleware('weappPassportWeb', 'ResetPassDialog')
@observer
export class ResetPassDialog extends React.Component<ResetPassDialogProps> {

  state = {
    dialogVisible: true,
  }

  componentDidMount(): void {
    this.props.resetPassStore?.setAccount(this.props.account);
    this.props.resetPassStore?.setOldPassword(this.props.oldPassword);
    this.props.resetPassStore?.formStore.initForm({
      items: {
        newPassword: {
          itemType: 'PASSWORD',
          required: true,
          placeholder: getLabel('93541', '请输入新密码')
          // placeholder: getLabel('154670','字母、数字、符号至少两种组合，不低于6位')
        },
        newPasswordAgain: {
          itemType: 'PASSWORD',
          required: true,
          placeholder: getLabel('154650', '请再次输入新密码')
        },
        passwordStrength: {
          itemType: "CUSTOM"
        }
      },
      layout: [
        [{
          id: "password",
          span: 24,
          wrapClassName: `${clsPrefix}-password`,
          label: getLabel('16759', '新密码'),
          items: ['newPassword', 'passwordStrength'],
          hide: false
        }],
        [{
          id: "passwordAgain",
          span: 24,
          label: getLabel('18997', '确认密码'),
          items: ['newPasswordAgain'],
          hide: false
        }]
      ],
      groups: [],
      data: {}
    })
  }

  refresh = () => {
    this.setState({});
  }

  render(): React.ReactNode {
    const { dialogVisible } = this.state;
    const { title, icon, info, resetPassStore } = this.props;
    const { formStore, loading } = resetPassStore!;
    return (
      <Dialog weId={`${this.props.weId || ''}_06jnh1`} title={title || getLabel('154575', '修改密码')}
        className={`${clsPrefix}`}
        closable={false}
        visible={dialogVisible}
        width={500}
        footer={[
          <Button weId={`${this.props.weId || ''}_64sqie@1`}
            onClick={() => this.props.resetPassStore?.submit(() => {
              this.setState({ dialogVisible: false });
              this.props.onOk && this.props.onOk();
            })}
            disabled={loading}
            type="primary">
            {getLabel('12694', '确认')}
          </Button>
        ]}
        icon={icon as any}>
        <Alert weId={`${this.props.weId || ''}_qonvqw`}
          message={info || getLabel('154580', '您上次使用的是被管理员修改或重置的密码，请立即修改密码，以保障账号安全')}
          className={`${clsPrefix}-info`}
          type="info" />
        <Spin weId={`${this.props.weId || ''}_c4bpbc`} spinning={loading}>
          <Form weId={`${this.props.weId || ''}_2yzjae`}
            store={formStore}
            onChange={(data?: FormDatas) => {
              this.refresh();
              data && Object.keys(data).includes("newPassword") && resetPassStore?.updateData({ password: data?.newPassword })
            }}
            customRenderFormSwitch={(item) => {
              switch (item) {
                case "passwordStrength":
                  return <PasswordStrength weId={`${this.props.weId || ''}_55bjsu`} value={formStore.getFormDatas().newPassword} />;
                default:
                  return null;
              }
            }} />
        </Spin>
      </Dialog>
    );
  }
}

export class ResetPass {
  static showDialog = (props: ResetPassDialogProps) => {
    return new Promise((resolve, reject) => {
      const div = document.createElement('div');
      document.body.appendChild(div);
      ReactDOM.render(<ResetPassDialog weId={`_vh7gc0`}
        onOk={() => {
          resolve(null);
        }}
        {...props} />, div);
    })
  }
}